import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-administrator-side-menu",
  templateUrl: "./administrator-side-menu.component.html",
  styleUrls: ["./administrator-side-menu.component.scss"],
})
export class AdministratorSideMenuComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  goTo(path: string) {
    this.router.navigate([`/${path}`]);
  }
}
